/** .........
 * The type of redux action to enter (or rather initiate entering)
 * picture-in-picture.
 *
 * {
 *      type: ENTER_PICTURE_IN_PICTURE
 * }
 *
 * @public
 */
export const ENTER_PICTURE_IN_PICTURE = 'ENTER_PICTURE_IN_PICTURE';

/**
 * The type of redux action to set the PiP active state,
 * driven by native iOS PiP lifecycle events.
 *
 * {
 *      type: SET_PIP_ACTIVE,
 *      isPictureInPictureActive: boolean
 * }
 */
export const SET_PIP_ACTIVE = 'SET_PIP_ACTIVE';
